<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">عرض البيانات</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />
    <!--begin::Body-->
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">التصنيف:</label>
          <div>{{ (dataRow.category)? questionCategories[dataRow.category] : 'غير محدد' }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">السؤال - عربي:</label>
          <div>{{ question }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">السؤال - إنجليزي:</label>
          <div>{{ questionEn }}</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label for="" class="form-label">الإجابة - عربي:</label>
          <div><pre>{{ answer }}</pre></div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 mb-3">
          <label for="" class="form-label">الإجابة - إنجليزي:</label>
          <div class="english-input"><pre>{{ answerEn }}</pre></div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">ترتيب الظهور:</label>
          <div>{{ sortNum }}</div>
        </div>
        <div class="col-12 col-sm-6 mb-3">
          <label for="" class="form-label">الحالة:</label>
          <div>{{ (isActive)? 'نشط' : 'غير نشط' }}</div>
        </div>
      </div>
    </div>
    <!--end::Body-->
  </div>
</template>

<script>
export default {
  name: 'QuestionsView',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      question: '',
      questionEn: '',
      answer: '',
      answerEn: '',
      sortNum: 0,
      isActive: true,
    }
  },
  created(){
    if(this.dataRow){
      this.question = this.dataRow.question;
      this.questionEn = this.dataRow.questionEn;
      this.answer = this.dataRow.answer;
      this.answerEn = this.dataRow.answerEn;
      this.sortNum = this.dataRow.sortNum;
      this.isActive = this.dataRow.isActive;
    }
  }
}
</script>
